import {RSAA} from "redux-api-middleware";
import * as types from "./types";

export function getLeaderboard(instance_id) {
    return {
        [RSAA]: {
            endpoint: `${process.env.API_HOST}/game/api/games/${instance_id}/leaderboard`,
            method: 'POST',
            headers: types.defaultHeaders,
            types: [
                types.LEADERBOARD_LIST,
                types.LEADERBOARD_LIST_SUCCESS,
                types.LEADERBOARD_LIST_ERROR
            ],
            credentials: 'same-origin'
        },
        auth: true
    };
}
